import $ from 'jquery';
import run from '../../utilities/run';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

run("#collateral-rule-details-page", ()=>{
  const activateBtn = ".activate";
  const inactivateBtn = ".delete";
  const collateralRuleDetailsPage = $("#collateral-rule-details-page");
  const activateUrl = collateralRuleDetailsPage.data("activate-rule-url");
  const inactivateUrl = collateralRuleDetailsPage.data("inactivate-rule-url");
  const pageRefreshUrl = collateralRuleDetailsPage.data("page-refresh-url");
  const collateralProducts = collateralRuleDetailsPage.data("mapped-collateral-products");
  const rule = collateralRuleDetailsPage.data("rule");
  const activateModalTitleTxt = collateralRuleDetailsPage.data("activate-modal-title-txt");
  const activateModalBodyTxt = collateralRuleDetailsPage.data("activate-modal-body-txt");
  const activateModalBtnTxt = collateralRuleDetailsPage.data("activate-modal-btn-txt");
  const inactivateModalTitleTxt = collateralRuleDetailsPage.data("inactivate-modal-title-txt");
  const inactivateModalBodyTxt = collateralRuleDetailsPage.data("inactivate-modal-body-txt");
  const inactivateModalBtnTxt = collateralRuleDetailsPage.data("inactivate-modal-btn-txt");

  init();

  function init(){
    if(!collateralProducts && collateralProducts.length <= 0) {
      $(".add-collateral-btn-outer").show();
      $(".collateral-rule-text").hide();
      $(".collateral-rules-table-outer").hide();
    }

    if(rule.isRuleExpired) {
      $(".rule-expired-on-message").show();
    }
  }

  $(activateBtn).click(function() {
    const button = $(this);
    if(button.hasClass("disabled")) {
        return;
    }
    const submitModalFlow = new SubmitModalFlow({
      confirmModalTitle: activateModalTitleTxt,
      confirmModalBody: `<div class="q-pad-all-xl">${activateModalBodyTxt}</div>`,
      confirmModalBtnText: activateModalBtnTxt,
      onConfirmClick: function() {
        submitModalFlow.showLoadingModal();
        $.ajax({
          url: activateUrl,
          dataType:"JSON",
          type: 'POST',
          success: onSuccessActivate,
          error: onErrorActivate
        });

        function onSuccessActivate() {
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            location.href = pageRefreshUrl;
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        }

        function onErrorActivate() {
          submitModalFlow.hideAllModals();
        }
      }
    });
    submitModalFlow.init();
    submitModalFlow.showConfirmModal();
  });

  $(inactivateBtn).click(function() {
    const submitModalFlow = new SubmitModalFlow({
      confirmModalTitle: inactivateModalTitleTxt,
      confirmModalBody: `<div class="q-pad-all-xl">${inactivateModalBodyTxt}</div>`,
      confirmModalBtnText: inactivateModalBtnTxt,
      onConfirmClick: function() {
        submitModalFlow.showLoadingModal();
        $.ajax({
          url: inactivateUrl,
          dataType:"JSON",
          type: 'POST',
          success: onSuccessInactivate,
          error: onErrorInactivate
        });

        function onSuccessInactivate() {
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            location.href = pageRefreshUrl;
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        }

        function onErrorInactivate() {
          submitModalFlow.hideAllModals();
        }
      }
    });
    submitModalFlow.init();
    submitModalFlow.showConfirmModal();
  });

});


// WEBPACK FOOTER //
// ./src/pages/createRule/collateralRuleDetailsPage.js